import { render } from "./fplogo.vue?vue&type=template&id=47ab5124&scoped=true&ts=true"
import script from "./fplogo.vue?vue&type=script&lang=ts"
export * from "./fplogo.vue?vue&type=script&lang=ts"

import "./fplogo.vue?vue&type=style&index=0&id=47ab5124&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ab5124"]])

export default __exports__